export default __webpack_public_path__ + "static/media/gallery_05.cbdd07eb.jpg";